import { useLocation } from '@/services/router/compat';
import { getWorkspaceIdFromCurrentUrl } from '@/utils/workspace-id';

export function useWorkspaceIdFromCurrentUrl(): number | null {
  const location = useLocation();
  return getWorkspaceIdFromCurrentUrl(location.pathname);
}
